import React from 'react'

const Foot = () => {
  return (
    <footer className="footer">
        <div className="container-fluid d-flex justify-content-between">
        
        <div className="copyright">
            Festrutif &copy; 2025
        </div>
        </div>
    </footer>
  )
}
export default Foot;